<script>

import Service from '../../services/material-balance'
import Toolbar from 'primevue/toolbar';
import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';
import config from '../../common/genericPanelConf';

import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';

import { required, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import GenericDataTable from '../../components/generic/GenericDataTable.vue';

const checkRevisionDescription = helpers.withMessage("Version can't be OBR0 when the Status is PLAN", function(el){
  if((this.proposedTempHeader.nextRevisionDescription === 'OBR0' || this.proposedTempHeader.nextRevisionDescription === 'obr0') && this.proposedTempHeader.nextStatus === 'PLAN'){    
      return false;    
    }
  return true;
});

export default {
    setup: () => ({ v$: useVuelidate() }),
    props: [],
    components: { Toolbar, ResponsiveButton, GenericDataTable },
    data() {
        return {
            periodDate: Utils.setDay(new Date(), 1),
            versions: [],
            currentVersion: {importDate: null},
            currentPeriod: null,
            activeTab: 0,
            proposedTempHeader: {
                actualRevisionNumber: null,
                balanceSheetDate: null,
                nextRevisionNumber: null,
                nextRevisionDescription: null
            },
            submitted: false,
            uploadDisplay: false,
            dateFrom: null,
            dateTo: null,
            minDate: null,
            maxDate: null,
            revisions: [],
            currentRevision: null,
            allProcessingProductionTemp: [],
            confirmedDetail: [],
            expandedRows: [],
            noAvailablePeriods: false,
            confirmImportDialogVisible: false,
            confirmStatus: 'OFFICIAL',
            confirmStatusList: ['OFFICIAL', 'PLAN'],
            planVersionList: ['OBR1','OBR2', 'OBR3', 'OBR4', 'OBR5', 'OBR6', 'OBR7', 'OBR8', 'OBR9', 'OBR10']
        }
    },
    created() {
        this.proposedConfiguration = config.getConfiguration('ProcessingProductionProposed');
    },
    validations() {
        return {
            periodDate: { required },
            proposedTempHeader: {
                nextRevisionDescription: { required, checkRevisionDescription }
            },
            dateFrom: { required },
            dateTo: { required }

        }
    },
    mounted() {
        this.$store.dispatch('security/setNavbarTitle', 'processingProduction.page_title');
        this.loadVersions();
        this.loadProposedTempHeader();
    },
    watch: {
        periodDate(newValue){
            this.currentVersion = {importDate: null};
            this.currentPeriod = null;
            this.currentRevision = null;
            this.versions = [];
            this.revisions = [];
            this.$refs.ProcessingProductionProposedGrid.resetGrid();

            if (newValue) {
                this.loadVersions();
                this.loadProposedTempHeader();
            }
        },
        'currentVersion.value'(value) {
            if (value) {
                this.$store.dispatch("generic/setLoading", true);

                Service.getProcessingProductionById(this.currentVersion.id, ({success, data}) => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(success){
                        const result = {};
                        data.detail.forEach((product) => {
                            const productId = product.idRegistryProduct;
                            if (!result[productId]) {
                                result[productId] = {
                                    idRegistryProduct: productId,
                                    registryProduct: product.registryProduct,
                                    totalQuantity: 0,
                                    history: [],
                                };
                            }
                            result[productId].totalQuantity += product.totalQuantity;
                            product.startPeriodDate = Utils.formatDate(product.startPeriodDate);
                            product.endPeriodDate = Utils.formatDate(product.endPeriodDate);
                            result[productId].history.push(product);
                        });
                        this.confirmedDetail = Object.values(result);
                    }
                })
            } else {
                this.confirmedDetail = [];
            }
        },
        'currentPeriod.value'(id){
            if(id){
                let filters = [];
    
                filters.push({
                    operator: 'eq',
                    value: id,
                    property: 'IdMaterialBalanceProcessingProductionHeaderTemp',
                });

                this.$refs.ProcessingProductionProposedGrid.setGlobalFilters(filters);
                this.$refs.ProcessingProductionProposedGrid.filterFromView(filters);
            } else {
                this.$refs.ProcessingProductionProposedGrid.resetGrid();
            }
        },
        currentPeriod(newValue) {
            if(!newValue){
                this.currentPeriod = null;
            }
        },
        uploadDisplay(newValue){
            if (newValue) {
                this.loadProposedTempHeader();
            } else {
                this.dateFrom = null;
                this.dateTo = null;
            }
        },
        currentRevision(newValue){
            if (newValue && (newValue.value !== this.currentVersion?.value)) this.currentVersion = null;
            this.$refs.ProcessingProductionProposedGrid.resetGrid();
        },
        periods(value){
            if(value.length === 1){
                this.currentPeriod = this.periods[0];
            }
        }
    },
    computed: {
        constants() {
            return CommonConstants;
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        },
        periods() {
            return this.currentRevision ? 
                this.allProcessingProductionTemp.filter(({revisionNumber}) => revisionNumber === this.currentRevision.value).map(({startPeriodDate, endPeriodDate, id, registryImportState, revisionNumber, importDate, fileReferenceCode, revisionDescription, status}) => 
                ({label: `${new Date(startPeriodDate).getDate()} - ${new Date(endPeriodDate).getDate()}`, value: id, registryImportState, revisionNumber, importDate, fileReferenceCode, revisionDescription, status})) : []
        }
    },
    methods: {
        onChangePeriod(event){
            this.periodDate = event;
        },
        loadVersions() {
            let filters = [];

            filters.push({
                operator: 'eq',
                value: Utils.formatDateForAPI(this.periodDate),
                property: 'BalanceSheetDate',
            });

            let params = {
                filter: JSON.stringify(filters),
                sort: JSON.stringify([{property: 'RevisionNumber', direction: 'asc'}])
            }
            this.$store.dispatch("generic/setLoading", true);
            Service.getProcessingProduction(params, ({success, data}) => {
                this.$store.dispatch("generic/setLoading", false);
                if(success){
                    this.versions = data.map(({revisionNumber, importDate, id, status, revisionDescription}) => ({label: `${revisionNumber} - ${Utils.formatDate(importDate)} - ${status} - ${revisionDescription}`, value: revisionNumber, id}));
                }
            })
        },
        loadProposedTempHeader(importId = null){
            const balanceSheetDate = Utils.formatDateForAPI(this.periodDate);
            Service.getProcessingProductionProposedTempHeader({balanceSheetDate: balanceSheetDate}, ({success, data}) => {
                if(success){
                    this.proposedTempHeader = data;
                    if(this.proposedTempHeader.availablePeriods.length){
                        this.noAvailablePeriods = false;
                        this.minDate = new Date(this.proposedTempHeader.availablePeriods.reduce((prev, curr) => {
                            prev.startPeriodDate < curr.startPeriodDate ? prev : curr;
                        }).startPeriodDate);
                        this.maxDate = new Date(this.proposedTempHeader.availablePeriods.reduce((prev, curr) => {
                            prev.endPeriodDate < curr.endPeriodDate ? prev : curr;
                        }).endPeriodDate);
                    } else {
                        this.noAvailablePeriods = true;
                    }

                    let filters = [];

                    filters.push({
                        operator: 'eq',
                        value: Utils.formatDateForAPI(this.periodDate),
                        property: 'BalanceSheetDate',
                    });

                    filters.push({
                        operator: '!=',
                        value: 1,
                        property: 'IdRegistryImportState'
                    });

                    let params = {
                        filter: JSON.stringify(filters),
                    }
                    Service.getProcessingProductionTemp(params, ({success, data}) => {
                        if(success){
                            if (data.length) {
                                this.allProcessingProductionTemp = data;
                                this.revisions = [...new Set(data.map(({revisionNumber}) => revisionNumber))].map((item) => ({value: item, label: item}));
                                if (importId){
                                    this.currentPeriod = this.periods.find((item) => item.value === importId)
                                }
                            }
                        }
                    })
                }
             })
        },
        exportExcel() {
            const balanceSheetDate = Utils.formatDateForAPI(this.periodDate);
            
            let params = {
                balanceSheetDate
            };
            
            this.$store.dispatch("generic/setLoading", true);
            Service.exportMaterialBalanceProcessingProduction(params, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                
                    fileLink.href = fileURL;
                    fileLink.setAttribute('download', balanceSheetDate + '.xlsx');
                    document.body.appendChild(fileLink);
                
                    fileLink.click();
                }else{
                    this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        async uploaderResponseMethod(file){
            const toBase64 = file => new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = () => resolve(reader.result.split(',')[1]);
                reader.onerror = reject;
            });
            const base64 = await toBase64(file.files[0]);
            let formData = {
                balanceSheetDate: Utils.formatDateForAPI(this.periodDate),
                revisionNumber: this.proposedTempHeader.nextRevisionNumber,
                startPeriodDate: Utils.formatDateForAPI(this.dateFrom),
                endPeriodDate: Utils.formatDateForAPI(this.dateTo),
                fileContent: base64,
                status: this.proposedTempHeader.nextStatus,
                revisionDescription: this.proposedTempHeader.nextRevisionDescription
            }
            this.$store.dispatch("generic/setLoading", true);

            Service.importFromFile(formData, response => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                    this.$toast.add({detail: this.$t('tankManagement.toastUploadSuccesMessage'), life:3000, severity:'success'});
                    this.uploadDisplay = false;


                    let filters = [];
    
                    filters.push({
                        operator: 'eq',
                        value: response.data.id,
                        property: 'IdMaterialBalanceProcessingProductionHeaderTemp',
                    });
                    this.$refs.ProcessingProductionProposedGrid.filterFromView(filters);
                    this.currentRevision = {label: response.data.revisionNumber, value: response.data.revisionNumber};
                    this.loadProposedTempHeader(response.data.id)
                }else{
                    this.$toast.add({detail: "Error: " + response.message, life:5000, severity:'error'});
                    this.uploadDisplay = false;
                }
            })                   
        },
        onDialogEditSave(data){
            this.$store.dispatch("generic/setLoading", true);
            Service.updateTempRecord(data, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    this.$refs.ProcessingProductionProposedGrid.hideDialogEdit();
                    this.$refs.ProcessingProductionProposedGrid.loadData();
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        confirmImport(){
            this.$confirm.require({
                message: this.$t('messages.confirm_import'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {

                    this.$store.dispatch("generic/setLoading", true);
                    Service.confirmImport({balanceSheetDate: Utils.formatDateForAPI(this.periodDate), revisionNumber: this.currentRevision.value, status: this.confirmStatus}, (response) => {
                        this.$store.dispatch("generic/setLoading", false);
                        if (response.success) {
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                            this.loadVersions();
                            this.$refs.ProcessingProductionProposedGrid.loadData();
                            this.loadProposedTempHeader();
                            this.confirmImportDialogVisible = false;
                        } else {
                            this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        deleteTemp(){
            this.$confirm.require({
                message: this.$t('messages.delete_message_question'),
                icon: 'pi pi-exclamation-triangle',
                acceptLabel: this.$t('yes'),
                rejectLabel: this.$t('no'),
                accept: () => {

                    this.$store.dispatch("generic/setLoading", true);
                    Service.deleteTempImport(this.currentPeriod.value, (response) => {
                        this.$store.dispatch("generic/setLoading", false);
                        if (response.success) {
                            this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                            this.$refs.ProcessingProductionProposedGrid.resetGrid();
                            this.loadProposedTempHeader();
                            this.currentPeriod = null;
                        } else {
                            this.$toast.add({ detail: response?.message && response?.message != '' ? response?.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                        }
                    })
                },
                reject: () => {
                    //callback to execute when user rejects the action
                    this.$confirm.close();
                }
            });
        },
        onConfirmImportClick(){
            this.confirmStatus = 'OFFICIAL';
            this.confirmImportDialogVisible= true;
        },
        onCheckDisabled(){
            return this.proposedTempHeader.nextStatus == 'OFFICIAL';
        },
        setValueVersion(){
            if(this.proposedTempHeader.nextStatus == 'OFFICIAL'){
                this.proposedTempHeader.nextRevisionDescription = 'OBR0';
            }else{
                this.proposedTempHeader.nextRevisionDescription = this.proposedTempHeader.actualRevisionDescription;
            }
        }
    },
}

</script>

<template>
    <main>
        <!--<Dialog v-model:visible="confirmImportDialogVisible" modal>
            <div class="grid">
                <div class="col-12 field">
                    <label>{{ $t('status') }}</label>
                    <Dropdown
                        :options="confirmStatusList"
                        class="w-full p-inputtext-sm mt-1"
                        v-model="confirmStatus" />
                </div>
            </div>
            
            <div class="flex justify-content-end gap-2">
                <Button type="button" class="m-2" :label="$t('btn.cancel')" severity="secondary" @click="confirmImportDialogVisible = false"></Button>
                <Button type="button" class="m-2" :label="$t('btn.save')" icon="pi pi-save" @click="confirmImport"></Button>
            </div>
    
        </Dialog>-->


        <Dialog v-model:visible="uploadDisplay" :style="{ width: '350px' }" modal>
            <template #header>
                <h3>{{$t('tankManagement.uploadHeader')}}</h3>
            </template>
            <div class="grid">
                <div class="col-12 field">
                    <label>{{ $t('processingProduction.periodDate') }}</label>
                    <Calendar
                        class="p-inputtext-sm w-full"
                        placeholder="MM/AAAA"
                        :modelValue="periodDate"
                        :disabled="true"
                        view="month" dateFormat="mm/yy" :showTime="false"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                </div>

                <div class="col-12 field">
                    <label>{{ $t('status') }}</label>
                    <Dropdown
                    :disabled="!confirmStatusList.length || this.proposedTempHeader.actualRevisionDescription"
                    :options="confirmStatusList"
                    :highlightOnSelect="false"
                    class="p-inputtext-sm w-full"
                    @change="setValueVersion()"
                    v-model="proposedTempHeader.nextStatus" />
                </div>
                
                <div class="col-12 field">
                    <label :class="{ 'p-error': v$.proposedTempHeader.nextRevisionDescription.$invalid }">{{ $t('processingProduction.version') }}</label>
                    <InputText v-model="proposedTempHeader.nextRevisionDescription" :disabled="onCheckDisabled()" 
                        :class="{ 'p-invalid': v$.proposedTempHeader.nextRevisionDescription.$invalid, 'p-inputtext-sm w-full': true }" 
                        v-if="proposedTempHeader.nextStatus == 'OFFICIAL'"/>

                    <Dropdown
                    :disabled="!planVersionList.length || this.proposedTempHeader.actualRevisionDescription"
                    :options="planVersionList"
                    :highlightOnSelect="false"
                    class="p-inputtext-sm w-full"
                    v-model="proposedTempHeader.nextRevisionDescription" 
                    v-if="proposedTempHeader.nextStatus == 'PLAN'"/>
                    
                    <div v-if="(v$.proposedTempHeader.nextRevisionDescription.$invalid) || v$.proposedTempHeader.nextRevisionDescription.$pending.$response">
                        <small class="p-error" v-for="error in v$.proposedTempHeader.nextRevisionDescription.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>

                <!--<div class="col-12 field">
                    <label>{{ $t('processingProduction.version') }}</label>
                    <InputText v-model="proposedTempHeader.nextRevisionNumber" :disabled="true" class="p-inputtext-sm w-full"/>
                </div>-->

                <div class="col-12 field">
                    <label :class="{ 'p-error': v$.dateFrom.$invalid }">{{ $t('processingProduction.dateFrom') }}</label>
                    <Calendar
                        :class="{ 'p-invalid': v$.dateFrom.$invalid, 'p-inputtext-sm w-full': true }"
                        placeholder="DD/MM/AAAA"
                        v-model="dateFrom"
                        :minDate="minDate" :maxDate="maxDate" 
                        dateFormat="dd/mm/yy" :showTime="false"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />

                    <div v-if="(v$.dateFrom.$invalid) || v$.dateFrom.$pending.$response">
                        <small class="p-error" v-for="error in v$.dateFrom.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
                <div class="col-12 field">
                    <label :class="{ 'p-error': v$.dateTo.$invalid }">{{ $t('processingProduction.dateTo') }}</label>
                    <Calendar
                        :class="{ 'p-invalid': v$.dateTo.$invalid, 'p-inputtext-sm w-full': true }"
                        placeholder="DD/MM/AAAA"
                        v-model="dateTo"
                        :minDate="minDate" :maxDate="maxDate" 
                        dateFormat="dd/mm/yy" :showTime="false"
                        :showIcon="true" :showButtonBar="true" :yearNavigator="true" />

                    <div v-if="(v$.dateTo.$invalid) || v$.dateTo.$pending.$response">
                        <small class="p-error" v-for="error in v$.dateTo.$silentErrors" :key="error.$validator">
                            {{error.$message}}
                        </small>
                    </div>
                </div>
            </div>
            <FileUpload name="uploaded[]" :customUpload="true" @uploader="uploaderResponseMethod" 
            :previewWidth="0" :fileLimit="1" :multiple="false" 
            :disabled="v$.proposedTempHeader.nextRevisionDescription.$invalid || v$.dateTo.$invalid || v$.dateFrom.$invalid"/>                    
        </Dialog>
        <Toolbar>
            <template #start>
                <div class="formgrid grid">
                    <div class="col-12 lg:col-4 field">
                        <label :class="{ 'p-error': v$.periodDate.$invalid && submitted }">{{ $t('processingProduction.periodDate') }}</label>
                        <Calendar
                            :class="{ 'p-invalid': v$.periodDate.$invalid && submitted, 'p-inputtext-sm w-full': true }"
                            placeholder="MM/AAAA"
                            :modelValue="periodDate"
                            view="month" dateFormat="mm/yy" :showTime="false" @update:modelValue="onChangePeriod"
                            :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                        <div v-if="(v$.periodDate.$invalid && submitted) || v$.periodDate.$pending.$response">
                            <small class="p-error" v-for="error in v$.periodDate.$silentErrors"
                                :key="error.$validator">
                                {{ error.$message }}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-4 field" v-if="activeTab === 1">
                        <label>{{ $t('processingProduction.version') }}</label>
                        <Dropdown
                            :disabled="!versions.length"
                            :options="versions"
                            optionLabel="label"
                            class="w-full p-inputtext-sm mt-1"
                            v-model="currentVersion" />
                    </div>
                    <div class="col-12 flex align-items-center lg:col-8 my-4">
                        <ResponsiveButton :label="$t('btn.export')" :disabled="!uiPermissions('processingProductionExportButton').isEnabled" icon="pi pi-file" @click="exportExcel" class="p-button-sm p-button-outlined m-1" />
                        <ResponsiveButton :label="$t('processingProduction.btn.importFrom')"
                            :disabled="noAvailablePeriods || !uiPermissions('processingProductionImportFromButton').isEnabled"
                            @click="uploadDisplay = true"
                            icon="pi pi-upload" class="p-button-sm p-button-outlined m-1" />
                        <span class="pi pi-info-circle import-info" v-tooltip="$t('messages.confirm_pending_processing_production_before_import')" v-if="noAvailablePeriods"></span>
                    </div>
                </div>
            </template>
        </Toolbar>
        <div class="col-12">
            <TabView v-model:activeIndex="activeTab">
                <TabPanel :header="$t('processingProduction.imported')" >
                    <Toolbar>
                        <template #start>
                            <div class="field ml-4">
                                <label class="block mt-2">{{ $t('processingProduction.revision') }}</label>
                                <Dropdown
                                    :options="revisions"
                                    optionLabel="label"
                                    class="w-full p-inputtext-sm mt-1"
                                    v-model="currentRevision" />
                            </div>
                            <div class="field ml-4">
                                <label class="block mt-2">{{ $t('processingProduction.period') }}</label>
                                <Dropdown
                                    :disabled="!periods.length"
                                    :options="periods"
                                    optionLabel="label"
                                    class="w-full p-inputtext-sm mt-1"
                                    v-model="currentPeriod" />
                            </div>
                            <div class="field ml-4">
                                <label class="block mt-2">{{ $t('processingProduction.importDate') }}</label>
                                <badge class="mt-1 p-badge-lg">{{ (currentRevision?.value && currentPeriod?.label) ? utils.formatDate(currentPeriod.importDate) : 'DD/MM/AAAA' }}</badge>
                            </div>
                            <div class="field ml-4">
                                <label class="block mt-2">{{ $t('processingProduction.fileReferenceCode') }}</label>
                                <badge class="mt-1 p-badge-lg">{{ currentPeriod?.fileReferenceCode || "-" }}</badge>
                            </div>
                            
                            <div class="field ml-4">
                                <label class="block mt-2">{{ $t('processingProduction.importStatus') }}</label>
                                <badge class="mt-1 p-badge-lg p-badge-success" v-if="currentRevision?.value && currentPeriod?.label">{{ currentPeriod.registryImportState }}</badge>
                                <badge class="mt-1 p-badge-lg" v-else>{{ '-' }}</badge>
                            </div>

                            <div class="field ml-4">
                                <label class="block mt-2 mx-2" style="visibility: hidden;">{{ $t('processingProduction.recordFileState') }}</label>
                                <badge class="mt-1 mx-2 p-badge-lg p-badge-warning">{{ currentPeriod?.status || "-" }}</badge>
                                <badge class="mt-1 p-badge-lg p-badge-warning">{{ currentPeriod?.revisionDescription || "-" }}</badge>
                            </div>
                        </template>
                        <template #end>
                            <div class="formgrid grid">
                                <div class="col-12 my-4">
                                    <ResponsiveButton :label="$t('btn.confirm')"
                                        :disabled="!uiPermissions('processingProductionConfirmImportButton').isEnabled"
                                        @click="confirmImport()"
                                        icon="pi pi-check" class="p-button-sm p-button-outlined m-1" />
                                    <ResponsiveButton :label="$t('btn.cancel')"
                                        :disabled="!currentPeriod || !uiPermissions('processingProductionDeleteTempButton').isEnabled"
                                        icon="pi pi-trash" class="p-button-sm p-button-warning m-1"
                                        @click="deleteTemp" />
                                </div>
                            </div>
                        </template>
                    </Toolbar>
                    <GenericDataTable :configuration="proposedConfiguration" :category="'material-balance'" :name="'processing-production-proposed'"
                        ref="ProcessingProductionProposedGrid" :onDialogEditSave="onDialogEditSave" />
                </TabPanel>
                <TabPanel :header="$t('processingProduction.confirmed')" >
                    <DataTable :value="confirmedDetail" v-model:expandedRows="expandedRows" :dataKey="confirmedDetail.idRegistryProduct" showGridlines stripedRows>
                        <Column :expander="true" headerStyle="width: 3rem" />
                        <Column field="registryProduct" :header="$t('product.fk')"></Column>
                        <Column field="totalQuantity" :header="$t('processingProduction.totalQuantity')"></Column>
                        <template #empty>
                          {{ $t('noRecordsFound') }}
                        </template>
                        <template #expansion="slotProps">
                            <DataTable :value="slotProps.data.history" >
                                <Column field="startPeriodDate" :header="$t('processingProduction.dateFrom')" sortable></Column>
                                <Column field="endPeriodDate" :header="$t('processingProduction.dateTo')" sortable></Column>
                                <Column field="dailyAverageQuantity" :header="$t('processingProduction.dailyAverageQuantity')" sortable></Column>
                                <Column field="lastDayQuantity" :header="$t('processingProduction.lastDayQuantity')" sortable></Column>
                                <Column field="totalQuantity" :header="$t('processingProduction.totalQuantity')" sortable></Column>
                                <Column field="registryPlant" :header="$t('processingProduction.registryPlant')" sortable></Column>        
                            </DataTable>
                        </template>
                    </DataTable>
                </TabPanel>
            </TabView>
        </div>
    </main>
</template>
        
<style>

    .import-info {
        color: steelblue;
        font-size: 1.5rem;
    }

    .p-dropdown .p-dropdown-trigger {
        background: #2196F3;
        color: white;
        min-width: 2.357rem;
        border-top-right-radius: 3px;
        border-bottom-right-radius: 3px;
    }
     
</style>